import { useAjax, useMzMutation, useTranslation } from "@bsm/component";

export const useCreateScholarityMutation = () => {
    const ajax = useAjax();
    const t = useTranslation()

    return useMzMutation(
        (payload: Record<string, any>) => {
            return ajax.send({
                type: "POST",
                content_type: "application/json",
                url: "student/scholarity/create",
                data: payload,
            });
        },
        {
            error_message: t('SCHOLARITY_CREATION_ERROR')
        }
    );
}